import React, { useState } from 'react'
import { Box } from '@material-ui/core'
import { DynamicMuiIcon } from 'src/components/atoms'
import { SPSideMenu } from 'src/components/organisms/SPSideMenu'
import { useRouter } from 'next/router'
import { TRIAL_BANNER_HEIGHT } from '../TrialBanner'

export const SP_HEADER_HEIGHT = 50

export const SPHeader = ({ isTrialing }: { isTrialing: boolean }) => {
  const router = useRouter()
  const sideMenuTop = isTrialing ? TRIAL_BANNER_HEIGHT + SP_HEADER_HEIGHT : SP_HEADER_HEIGHT
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  return (
    <Box style={{ display: 'flex', alignItems: 'center', minHeight: SP_HEADER_HEIGHT }}>
      <Box
        style={{ position: 'absolute', left: '20px', display: 'flex', alignItems: 'center' }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <DynamicMuiIcon variant="menu" size={18} />
      </Box>
      <Box style={{ display: 'flex', alignItems: 'center', flexGrow: 1, justifyContent: 'center' }}>
        <img
          src="/images/nocosell_logo.svg"
          alt="nocosell"
          height="24px"
          width="93px"
          onClick={() => router.push('/')}
        />
      </Box>
      <Box position="fixed" height="100%" top={sideMenuTop} left={0} zIndex={1001}>
        <SPSideMenu isExpanded={isExpanded} />
      </Box>
    </Box>
  )
}
